/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacyCityTypename = "PharmacyCity" as const;

/**
 *
 * @export
 * @interface PharmacyCity
 */
export interface PharmacyCity {
  /**
   *
   * @type {string}
   * @memberof PharmacyCity
   */
  cityCode: string;
  /**
   *
   * @type {string}
   * @memberof PharmacyCity
   */
  name: string;
  /**
   *
   * @type {Array<number>}
   * @memberof PharmacyCity
   */
  pharmacyIds?: Array<number>;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacyCity
   */
  readonly __typename?: string;
}

export function PharmacyCityFromJSON(json: any): PharmacyCity {
  return PharmacyCityFromJSONTyped(json, false);
}

export function PharmacyCityFromJSONTyped(json: any, ignoreDiscriminator: boolean): PharmacyCity {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacyCityTypename,

    cityCode: json["city_code"],
    name: json["name"],
    pharmacyIds: !exists(json, "pharmacy_ids") ? undefined : json["pharmacy_ids"],
  };
}

export function PharmacyCityToJSON(object?: PharmacyCity | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    city_code: value.cityCode,
    name: value.name,
    pharmacy_ids: value.pharmacyIds,
  };
}
